<script>
    import { preventDefault } from "svelte/legacy";

    import { createEventDispatcher } from "svelte";
    import tagService from "../service.js";
    import { flatten422Errors, search } from "../../../services/api.svelte.js";
    import { translateErrorMessages } from "../../../services/api.svelte.js";
    import { format } from "svelte-i18n";

    const dispatch = createEventDispatcher();

    let { tag, assetsAssociated = $bindable([]) } = $props();

    let formData = {};
    let formDataPromise;
    let formIsSubmitted = false;
    // API string errors
    let APIerror = null;
    // API 422 errors
    let formApiErrors = {};
    let assets = [];
    let search_results;
    let showDropdown = false;
    let assetsToRemove = [];
    let assetKind;
    let is_edit;

    // add form
    if (!tag) {
        formDataPromise = Promise.resolve({});
        is_edit = false;
    }
    // edit form
    else {
        formData = {
            name: tag.name,
        };
        is_edit = true;
        if (assetsAssociated.length <= 0 && tag.asset) {
            assetsAssociated = JSON.parse(tag.asset);
        }
    }

    function handleSubmit() {
        formIsSubmitted = true;
        // reset API errors
        formApiErrors = {};
        let reqData = {};

        if (assetsToRemove.length > 0) {
            for (let asset of assetsToRemove) {
                reqData = {
                    tag_id: tag.id,
                    target_object_type: "Asset",
                    target_object_id: asset.id,
                };
            }
        }
        tagService
            .deleteAssociation(reqData, [], {})
            .then((response) => {
                dispatch("save", { tag });
                //clear formData and form status and errors
                // when modal is closed after sending add request
                formData = {};
                formIsSubmitted = false;
                formApiErrors = {};
                return true;
            })
            .catch((errors) => {
                if (typeof errors.detail == "string") {
                    APIerror = translateErrorMessages(
                        errors.detail,
                        "Etiquetas",
                    );
                } else {
                    // parse API errors
                    formApiErrors = flatten422Errors(errors);
                }

                return false;
            });
    }
    const removeAssociatedAsset = (i) => {
        assetsToRemove.push(assetsAssociated[i]);
        assetsAssociated.splice(i, 1);
        assetsAssociated = assetsAssociated;
    };

    function handleCloseModal() {
        formData = {};
        formApiErrors = {};
        formIsSubmitted = false;
        formIsSubmitted = false;
        showDropdown = true;
        APIerror = null;
        assetKind = null;
        assets = [];
        search_results = [];
        dispatch("closeModal");
    }

    const handleKeydown = (event) => {
        if (event.key == "Escape") {
            handleCloseModal();
        } else {
            return;
        }
    };
</script>

<svelte:window onkeydown={handleKeydown} />

<form role="form" novalidate onsubmit={preventDefault(handleSubmit)}>
    <div class="card">
        <div class="card-body">
            {#if tag}
                <div class="mb-3">
                    <label for="name"
                        >{$format("form.fields.name")}<span class="text-danger"
                            >*</span
                        ></label
                    >
                    <span class="d-block">{tag.name}</span>
                </div>
            {/if}

            {#if assetsAssociated.length > 0}
                <label for="associatedAssets"
                    >{$format("page.tag.associated_assets")}:</label
                >
                {#each assetsAssociated as asset, i}
                    <div>
                        {asset.nickname || asset.name}<i
                            class="fas fa-times btnDeleteAsset float-end"
                            onclick={() => removeAssociatedAsset(i)}
                        ></i>
                    </div>
                {/each}
            {/if}
        </div>
        <div class="card-footer">
            <button type="submit" class="btn btn-primary t-submit-tag-btn"
                >{$format("buttons.save")}</button
            >
            <button
                type="button"
                class="btn btn-default"
                data-bs-dismiss="modal"
            >
                {$format("buttons.cancel")}
            </button>
        </div>
    </div>
</form>

<style>
    .btnDeleteAsset {
        cursor: pointer;
    }
</style>
